'use strict';

//  ----------  MENU  -------------------------------------

var AdjustScrollingMixin = {

    adjustScrolling: function adjustScrolling() {

        var footer = $('.l-footer');
        var menu = $('.l-api-docs-menu');
        var threshold = 50;
        var defaultMenuTop = 16;
        var footerTop = footer.offset().top;
        var menuBottom = menu.offset().top + menu.height();

        var menuTop = parseInt(menu.css('top'), 10);
        var delta = Math.round(footerTop - menuBottom);

        if (delta < threshold) {
            // Move menu up
            menu.css('top', menuTop - (threshold - delta));
        } else if (menuTop < defaultMenuTop) {
            // top = menuTop + (footerTop - threshold - menuBottom)
            menu.css('top', menuTop + (footerTop - threshold - menuBottom));
        }
    }
};

module.exports = AdjustScrollingMixin;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/api-docs/api-menu/adjust-scrolling-mixin.jsx
 ** module id = 730
 ** module chunks = 0
 **/